export enum CustomerState {
  REQUEST = 'request',

  ACCEPTED = 'accepted',

  ONCARE = 'oncare',
}
